import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Button extends PureComponent {
    render() {
        const {
            theme,
            size,
            dropdown,
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['btn']: true,
            ['btn-' + theme]: true,
            ['btn-' + size]: true,
            ['dropdown-toggle']: dropdown
        });

        return (
            <button className={classNames} {...props}>
                {children}
            </button>
        );
    }
}

Button.defaultProps = {
    theme: 'primary',
    size: 'md',
    dropdown: false
};

export default Button;
